export default {
  title: 'Report firmati / live',
  column_groups: {
    current_period: 'Periodo corrente',
  },
  fields: {
    name: 'Nome',
    area: 'Area',
    signed: 'Firmati',
    live: 'Live',
    going_live: 'In attivazione',
    going_live_avg: 'Media attivazione',
    churned: 'Disdetti',
    not_live: 'Non live',
    live_ratio: 'Percentuale live',
    avg_mrr: 'MRR medio',
  },
  manager_status_filters: {
    active: 'Attivi',
    inactive: 'Inattivi',
    all: 'Tutti',
  },
  status_filters: {
    all: 'Tutti',
    not_live: 'Non live',
  },
  drawer: {
    title: '{{column}} — {{managerName}}',
    subtitle_one: '{{count}} ristorante',
    subtitle_other: '{{count}} ristoranti',
    empty: 'Nessun ristorante trovato.',
  },
  toasts: {
    failed_to_load_data: 'Caricamento dati non riuscito, aggiorna la pagina',
  },
};
